import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserCurrencyTransaction } from '../user-currency-transaction.model';

@JsonObject('UserTransactionsResultsResponse')
export class UserTransactionsResultsResponse extends ApiResultsResponse<UserCurrencyTransaction> {

  @JsonProperty('results', [UserCurrencyTransaction])
  override results: UserCurrencyTransaction[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
